export const EXISTING_SITE_MIGRATION_VERSION = '1.1.1';
